/* b2b-pricing-v8.js — Cart-Side B2B Pricing Engine */
(function() {
  'use strict';

  const cfg = window.__b2bConfig || {};
  if (!cfg.is_b2b) return; // nicht freigeschaltet — kein Cart-Hooking

  const GIFT_MUTEX_KEY = 'b2b_gift_lock_v8';
  const GIFT_MUTEX_TIMEOUT_MS = 3000;

  function acquireGiftLock() {
    const now = Date.now();
    const existing = parseInt(localStorage.getItem(GIFT_MUTEX_KEY) || '0', 10);
    if (existing && now - existing < GIFT_MUTEX_TIMEOUT_MS) return false;
    localStorage.setItem(GIFT_MUTEX_KEY, String(now));
    return true;
  }
  function releaseGiftLock() { localStorage.removeItem(GIFT_MUTEX_KEY); }

  async function fetchCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  function evaluateThresholdGifts(cart, rules, tierKey) {
    const expected = new Map();
    const totalPriceEur = (cart.total_price || 0) / 100;
    for (const r of rules) {
      const tierMatch = r.tier === '*' || r.tier === tierKey;
      if (!tierMatch) continue;
      if (totalPriceEur < r.min_cart_eur) continue;
      const key = String(r.variant_id);
      if (!expected.has(key)) expected.set(key, { qty: r.qty, ruleId: r.id, label: r.label });
    }
    return expected;
  }

  function evaluateFixedGifts(fixedGifts) {
    const expected = new Map();
    if (!fixedGifts || !Array.isArray(fixedGifts.variants)) return expected;
    for (const g of fixedGifts.variants) {
      expected.set(String(g.id), { qty: g.qty || 1, ruleId: 'fixed', label: g.note || 'Geschenk' });
    }
    return expected;
  }

  function getCurrentGifts(cart) {
    const current = new Map();
    for (const item of cart.items) {
      const props = item.properties || {};
      if (props._gift === 'true' || props._gift === true) {
        current.set(String(item.variant_id), { qty: item.quantity, lineKey: item.key });
      }
    }
    return current;
  }

  function computeDiff(expected, current) {
    const toAdd = []; const toRemove = [];
    for (const [vid, exp] of expected) {
      const cur = current.get(vid);
      if (!cur) toAdd.push({ variant_id: vid, qty: exp.qty, ruleId: exp.ruleId, label: exp.label });
      else if (cur.qty !== exp.qty) toAdd.push({ variant_id: vid, qty: exp.qty - cur.qty, ruleId: exp.ruleId, label: exp.label });
    }
    for (const [vid, cur] of current) {
      if (!expected.has(vid)) toRemove.push({ variant_id: vid, lineKey: cur.lineKey });
    }
    return { toAdd, toRemove };
  }

  async function applyDiff(diff) {
    for (const rm of diff.toRemove) {
      await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: rm.lineKey, quantity: 0 })
      });
    }
    if (diff.toAdd.length > 0) {
      await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: diff.toAdd.map(a => ({
            id: a.variant_id,
            quantity: a.qty,
            properties: { _gift: 'true', _gift_reason: a.ruleId }
          }))
        })
      });
    }
  }

  function evaluateBxgy(cart, bxgyRules) {
    const expected = new Map();
    if (!bxgyRules || !Array.isArray(bxgyRules.rules)) return expected;

    const cartQtys = new Map();
    for (const item of cart.items) {
      const props = item.properties || {};
      if (props._gift === 'true') continue;
      const k = String(item.variant_id);
      cartQtys.set(k, (cartQtys.get(k) || 0) + item.quantity);
    }

    for (const r of bxgyRules.rules) {
      const buyQty = cartQtys.get(String(r.buy_variant_id)) || 0;
      const multiples = Math.floor(buyQty / r.buy_qty);
      if (multiples > 0) {
        const key = String(r.get_variant_id);
        const getQty = multiples * r.get_qty;
        const prev = expected.get(key) || { qty: 0, ruleId: r.id, label: r.label || `BXGY-${r.id}` };
        expected.set(key, { qty: prev.qty + getQty, ruleId: r.id, label: prev.label });
      }
    }
    return expected;
  }

  async function evaluateAndSync() {
    if (!acquireGiftLock()) return;
    try {
      const cart = await fetchCart();
      if (cart.items.length === 0) return;
      const tierKey = cfg.customer?.tier_key || '';
      const expected = new Map([
        ...evaluateThresholdGifts(cart, cfg.gift_rules?.rules || [], tierKey),
        ...evaluateFixedGifts(cfg.customer?.fixed_gifts || null),
        ...evaluateBxgy(cart, cfg.bxgy_rules || null)
      ]);
      const current = getCurrentGifts(cart);
      const diff = computeDiff(expected, current);
      if (diff.toAdd.length || diff.toRemove.length) {
        await applyDiff(diff);
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    } finally {
      releaseGiftLock();
    }
  }

  ['cart:updated', 'cart:added', 'cart:changed'].forEach(ev => {
    document.addEventListener(ev, () => setTimeout(evaluateAndSync, 200));
  });

  if (window.location.pathname.startsWith('/cart')) {
    setTimeout(evaluateAndSync, 500);
  }

  window.__b2bEngine = { evaluateAndSync, fetchCart, evaluateThresholdGifts, evaluateBxgy };
})();
